export default function pieWidgetTooltip (series, dataFormatter) {
  function tooltip ({w, seriesIndex}) {
    const targetColor = w.config.colors[seriesIndex];
    const value = series[seriesIndex];
    const formatterValue = dataFormatter(value);
    const categoryName = w.config.labels[seriesIndex];

    const total = series.reduce((acc, item) => acc + item, 0);
    const percent = (value / total * 100).toFixed(0);

    // eslint-disable-next-line max-len
    return `<div class="apexcharts-tooltip-series-group apexcharts-active" style="order: 1; display: flex; background-color: ${targetColor}">` +
      '<div class="apexcharts-tooltip-text" style="font-family: Roboto, sans-serif; font-size: 12px;">' +
      '<div class="apexcharts-tooltip-y-group">' +
      `<span class="apexcharts-tooltip-text-y-label">${categoryName}</span>` +
      `<span class="apexcharts-tooltip-text-y-value">${formatterValue} (${percent} %)</span>` +
      '</div>' +
      '</div></div>';
  }
  return tooltip;
}
